import { useEffect, useState } from "react";
import { speak, cancelSpeech } from "./speech";
import type { SpeakButtonModel } from "../../type/speak";
import { mucisIcon, speakIcon } from "../../utils/config";
import "./speakButton.scss";
//import { useUserParameters } from "../../context/userParameters/userParametersContext";
import { getUser, isAuthenticated } from "../../auth/auth";
import type { UserModel } from "../../type/user";

const SpeakButton = ({ text, lang = "en", size = "default" }: SpeakButtonModel) => {
  const [isSpeaking, setIsSpeaking] = useState(false);
  //const { parameters } = useUserParameters();
  const [user, setUser] = useState<UserModel | null>(null);

  const handleSpeak = async () => {
    if (isSpeaking) {
      cancelSpeech();
      setIsSpeaking(false);
      return;
    }

    await speak(text, lang, 0.9, {
      onStart: () => {
        setIsSpeaking(true);
      },
      onEnd: () => {
        setIsSpeaking(false);
      }
    });
  };

  useEffect(() => {
    if (isAuthenticated()) {
      const userData = getUser();
      setUser(userData);
    }
  }, []);

  return (
    <>
    {user?.parameters?.speakbuttons_visible?.value && (
      <span className={` ${size === "large" ? "speak-button-wrapper--large" : ""}`.trim()}>
        <button
          type="button"
          className="speak-button"
          onClick={handleSpeak}
          title="Speak"
        >
          {isSpeaking ? (
            <span className="speech-icon">{mucisIcon}</span>

          ) : (
            <span className="speech-icon">{speakIcon}</span>
          )}
        </button>
      </span>
    )}
    </>
  );
};

export default SpeakButton;
